import { getPreferenceFromCache, setPreference } from "src/services/PreferenceStore";
import { InnerViewFilter, OneViewFilter, stringToView } from "../toLocalStorage";
import { getViews } from "./getViews";
import { stripViewFilterPrefix } from "./stripViewFilterPrefix";

type CreateOptions = {
    gridKey: string;
    view: OneViewFilter;
};
export const createNewView = (options: CreateOptions): OneViewFilter[] => {
    const { gridKey, view } = options;
    const preferenceKey = stripViewFilterPrefix(gridKey);

    const allPreviousValues = getViews({ gridKey });
    const previousAsObj = allPreviousValues.reduce((acc, currentValue) => {
        acc[currentValue.filterName] = JSON.stringify({
            columnFilters: currentValue.columnFilters,
            columnOrder: currentValue.columnOrder,
            columnVisibility: currentValue.columnVisibility,
        });
        return acc;
    }, {} as InnerViewFilter);

    const viewDataAsString = JSON.stringify({
        columnFilters: view.columnFilters,
        columnOrder: view.columnOrder,
        columnVisibility: view.columnVisibility,
    });

    const newFilter = {
        ...previousAsObj,
        [view.filterName]: viewDataAsString,
    };
    const newFilterAsString = JSON.stringify(newFilter);

    setPreference("grid.views", preferenceKey, newFilter);

    const currentOrder = getPreferenceFromCache<string[]>("grid.views.order", preferenceKey) ?? [];
    if (!currentOrder.includes(view.filterName)) {
        setPreference("grid.views.order", preferenceKey, [...currentOrder, view.filterName]);
    }

    const formattedOutput = stringToView(newFilterAsString);
    return formattedOutput;
};
